
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/392e4cb78101380174f7450cc13c94c4.jpg"
          alt="Adela's Family - Dallas Health Insurance Clients"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center text-white">
        <div className="max-w-4xl mx-auto">
          {/* Trust Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full mb-8 border border-white/20">
            <i className="ri-shield-check-line text-2xl text-teal-400"></i>
            <span className="text-sm font-medium">Trusted by Dallas's Premier Families Since 2015</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Dallas Health Insurance Experts
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-white/90 leading-relaxed">
            Premium Private Health Insurance for Highland Park, University Park & Park Cities Families
          </p>

          {/* Featured Client Testimonial Card */}
          <div className="bg-white/95 backdrop-blur-md rounded-2xl p-8 mb-10 max-w-3xl mx-auto shadow-2xl">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 flex items-center justify-center text-white text-3xl font-bold">
                  AF
                </div>
              </div>
              <div className="flex-1 text-left">
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-700 text-lg mb-4 italic leading-relaxed">
                  "Finding the right health insurance for our family of four seemed overwhelming until we found Dallas Health Insurance Experts. They took the time to understand our needs and found us comprehensive coverage that actually saves us money. We couldn't be happier!"
                </p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="text-gray-900 font-bold text-lg">Adela's Family</p>
                  <p className="text-teal-600 font-semibold">(214) 555-8742</p>
                  <p className="text-gray-600 text-sm mt-1">Highland Park Residents</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:2143060121"
              className="group bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-2xl"></i>
              Call (214) 306-0121
            </a>
            <a
              href="/contact"
              className="group bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 border-2 border-white/30 hover:border-white/50 flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              Get Free Consultation
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-3 gap-6 mt-16 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-teal-400 mb-2">500+</div>
              <div className="text-sm text-white/80">Dallas Families Served</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-teal-400 mb-2">98%</div>
              <div className="text-sm text-white/80">Client Satisfaction</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="text-4xl font-bold text-teal-400 mb-2">$3.2K</div>
              <div className="text-sm text-white/80">Average Annual Savings</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
